const ADMIN = 'admin' /** FRONT E BACK */
const ACESSAR_REI = 'acessar_rei' /** FRONT */
const NOVO_REGISTRO_RASCUNHO = 'novo_registro_rascunho' /** FRONT E BACK */
const NOVO_REGISTRO_CADASTRAR = 'novo_registro_cadastrar' /** BACK */
const PESQUISAR_REGISTROS = 'pesquisar_registros' /** BACK */
const ACESSAR_RESUMO = 'acessar_resumo_registro' /** FRONT */
const EDITAR_REGISTRO = 'editar_registro' /** FRONT */
const CADASTRAR_IMAGENS = 'cadastrar_imagens' /** BACK */
const CADASTRAR_AVERBACOES = 'cadastrar_averbacoes' /** BACK */
const IMPRIMIR_AVERBACOES = 'imprimir_averbacoes' /** BACK */
const LANCAR_OS = 'lancar_os' /** BACK E FRONT */
const MINUTAS_PRE_VISUALIZACAO = 'minutas_pre_visualizacao' /** FRONT */
const MINUTAS_IMPRIMIR_RASCUNHO = 'minutas_imprimir_rascunho' /** BACK */
const CADASTRAR_CUSTAS = 'cadastrar_custas' /** BACK */
const CADASTRAR_FUNERARIA = 'cadastrar_funeraria' /** BACK */
const CADASTRAR_HOSPITAIS = 'cadastrar_hospitais' /** BACK */
const CADASTRAR_LOCAL_SEPULTAMENTO = 'cadastrar_local_sepultamento' /** BACK */
const CADASTRAR_LOCAL_OBITO = 'cadastrar_local_obito' /** BACK */
const CADASTRAR_TIPOS_CAUSA_MORTE = 'cadastrar_tipos_causa_morte' /** BACK */
const CADASTRAR_SERVENTIA_DADOS_CARTORIO = 'cadastrar_serventia_dados_cartorio' /** BACK */
const CADASTRAR_SERVENTIA_USUARIOS = 'cadastrar_serventia_usuarios' /** BACK */
const CADASTRAR_SERVENTIA_GRUPOS_ACESSO = 'cadastrar_serventia_grupos_acesso' /** BACK */
const CADASTRAR_SERVENTIA_ACERVOS = 'cadastrar_serventia_acervos' /** BACK */
const GERENCIADOR_TAREFAS_VISUALIZAR = 'gerenciador_tarefas_visualizar' /** FRONT OK*/
const GERENCIADOR_TAREFAS_ENVIAR = 'gerenciador_tarefas_enviar' /** BACK */
const RESUMO_REGISTRO_ENVIAR_CARGA = 'resumo_registro_enviar_carga' /** FRONT */
const ACESSO_LIVRO_CAIXA = 'acesso_livro_caixa'
const ACESSO_RELATORIO_SERVICOS_RECOLHIMENTO = 'acesso_relatorio_servicos_recolhimento'

module.exports = {
  ADMIN,
  ACESSAR_REI,
  NOVO_REGISTRO_RASCUNHO,
  NOVO_REGISTRO_CADASTRAR,
  PESQUISAR_REGISTROS,
  ACESSAR_RESUMO,
  EDITAR_REGISTRO,
  CADASTRAR_IMAGENS,
  CADASTRAR_AVERBACOES,
  IMPRIMIR_AVERBACOES,
  LANCAR_OS,
  MINUTAS_PRE_VISUALIZACAO,
  MINUTAS_IMPRIMIR_RASCUNHO,
  CADASTRAR_CUSTAS,
  CADASTRAR_FUNERARIA,
  CADASTRAR_HOSPITAIS,
  CADASTRAR_LOCAL_SEPULTAMENTO,
  CADASTRAR_LOCAL_OBITO,
  CADASTRAR_TIPOS_CAUSA_MORTE,
  CADASTRAR_SERVENTIA_DADOS_CARTORIO,
  CADASTRAR_SERVENTIA_USUARIOS,
  CADASTRAR_SERVENTIA_GRUPOS_ACESSO,
  CADASTRAR_SERVENTIA_ACERVOS,
  GERENCIADOR_TAREFAS_VISUALIZAR,
  GERENCIADOR_TAREFAS_ENVIAR,
  RESUMO_REGISTRO_ENVIAR_CARGA,
  ACESSO_LIVRO_CAIXA,
  ACESSO_RELATORIO_SERVICOS_RECOLHIMENTO
}
